import React from "react";

// Yanked from https://github.com/RequestFinance/invoicing/blob/main/src/lib/useDisclosure.ts

interface DisclosableProps {
    isOpen: boolean;
    onClose(): void;
    onOpen(): void;
}

/**
 * React hook for controlling open/close state
 * Inspired from https://github.com/chakra-ui/chakra-ui/blob/main/packages/hooks/src/use-disclosure.ts
 */
export function useDisclosure(props: Partial<DisclosableProps> = {}) {
    const {
        onClose: onCloseProp,
        onOpen: onOpenProp,
        isOpen: isOpenProp,
    } = props;

    const [isOpen, setIsOpen] = React.useState(isOpenProp ?? false);

    const onClose = React.useCallback(() => {
        setIsOpen(false);
        onCloseProp?.();
    }, [onCloseProp]);

    const onOpen = React.useCallback(() => {
        setIsOpen(true);
        onOpenProp?.();
    }, [onOpenProp]);

    const onToggle = React.useCallback(() => {
        const action = isOpen ? onClose : onOpen;
        action();
    }, [isOpen, onOpen, onClose]);

    return {
        isOpen,
        onOpen,
        onClose,
        onToggle,
    };
}
